import { Box, factory, Flex, Link, omitText, Typography } from '@kohler-dsm-library/kohler-core';
import { ArrowDownBoldIcon, ArrowRightBoldIcon, ExternalLinkIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React from 'react';
import classes from './index.module.scss';

export const OverlayMenuCategory = factory((props, ref) => {
  const { className, title, links, showArrow = true, isExternal, opened = false, onToggle, isCTA = false, ...rest } = props;
  const isOpen = opened;
  const hasNoLinks = !links || links.length === 0;

  return (
    <Flex
      ref={ref}
      className={clsx(
        className,
        'kohler-overlay-menu-category-root',
        classes.overlayMenuCategory,
        isOpen && classes.overlayMenuCategoryOpen,
        isCTA && classes.overlayMenuCategoryCTA
      )}
      component="div"
      {...rest}
    >
      {title &&
        (!isCTA ? (
          <>
            <Box
              component={hasNoLinks ? 'a' : 'button'}
              target={hasNoLinks && isExternal ? '_blank' : undefined}
              {...omitText(title)}
              onClick={
                !links
                  ? title.onClick
                  : () => {
                    if (onToggle) onToggle();
                  }
              }
              className={clsx(
                classes.overlayMenuCategoryTitle,
                hasNoLinks ? classes.overlayMenuCategoryTitleLink : undefined,
                title.className
              )}
            >
              <Typography
                component="span"
                size="navigation-m"
                textColor="var(--Primary-Charcoal, #212121);"
                className={classes.overlayMenuCategoryTitleText}
              >
                {title.text} {!showArrow && hasNoLinks && isExternal && <ExternalLinkIcon size="small" withBoundingBox={false} />}
              </Typography>
              {showArrow && !hasNoLinks && (
                <ArrowDownBoldIcon
                  size="xSmall"
                  withBoundingBox={false}
                  className={clsx(classes.iconTransitionArrowClosed, isOpen && classes.iconTransitionArrowOpen, classes.arrowDownIcon)}
                />
              )}
            </Box>
            <div className={classes.overlayMenuCategoryDivider} />
          </>
        ) : (
          <Link size="small" underline={false} rightIcon={<ArrowRightBoldIcon size="small" withBoundingBox={false} />} {...omitText(title)}>
            {title.text}
          </Link>
        ))}
      {(isOpen || !title) && (
        <Flex component="ul" direction="column" gap={15} className={classes.overlayMenuCategoryLinks}>
          {!hasNoLinks &&
            links?.map((link) => (
              <Box key={link.href} component="li">
                <Typography
                  component="a"
                  size="navigation-s"
                  textColor="var(--content-action-default)"
                  {...omitText(link)}
                  className={classes.overlayMenuCategoryLinksLink}
                >
                  {link.text}
                </Typography>
              </Box>
            ))}
        </Flex>
      )}
    </Flex>
  );
});
